import { RootState } from '../../../config';

export const selectTexts = (state: RootState): any =>
  state.appData.texts.entities;
